module.exports = __webpack_public_path__ + "media/assets/save_icon-8150b047.svg";